'use strict';

var useEmailValidation = {};

exports.__exports = useEmailValidation;
//# sourceMappingURL=useEmailValidation.cjs.map
